// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.horse-show-name {
  font-size: 1.15rem;
  font-weight: 500;
  color: rgb(0,51,51);
}
.btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.9rem;
  line-height: 1.5;
  font-weight: 300;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/home/home.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".horse-show-name {\n  font-size: 1.15rem;\n  font-weight: 500;\n  color: rgb(0,51,51);\n}\n.btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  font-weight: 300;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
